<template>
  <div>
    <div class="message-card-item" v-for="(card, index) in cardList" :key="index" @click="onClick(card)">
      <template v-if="card.url">
        <div class="message-card-top">
          <div class="message-card-left">
            <van-image :src="card.url.logo" width="50" height="50" fit="contain" />
          </div>
          <div class="message-card-right">
            <div class="title ellipsis-1">{{card.url.name}}</div>
            <div class="title-sub ellipsis-1">{{card.url.boothno}}</div>
          </div>
        </div>
        <div class="message-card-bottom ellipsis-3">{{card.url.introduction}}</div>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "ExhibitorCard",
    props: {
      miniEnv: {
        type: Boolean,
        default: false
      },
      cardList: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters(['tenantId'])
    },
    methods: {
      onClick(card) {
        const id = card.url.exhibitor_id
        if (!id) {
          return
        }

        if (this.miniEnv) {
          if (this.tenantId === '242290') {
            // 科博会
            wx.miniProgram.navigateTo({
              url: '/pages/webview/index?meta=' + JSON.stringify({ type: 'exhibitor_info', id })
            })
          } else if (this.tenantId === '244043') {
            // SIAL西雅
            wx.miniProgram.navigateTo({
              url: '/pages/exhibitors/exhibitorsDetails/exhibitorsDetails?id=' + id
            })
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .message-card-item {
    padding: 12px 8px;
    box-sizing: border-box;
    margin-bottom: 8px;
    background: #ffffff;
    border-radius: 4px;
    &:last-child{
      margin-bottom: 0;
    }
    .message-card-top {
      display: flex;
    }
    .message-card-left {
      width: 50px;
      height: 50px;
    }
    .message-card-right {
      flex: 1;
      padding-left: 6px;
      box-sizing: border-box;
      min-width: 0;
      .title {
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        color: rgba(0,0,0,0.85);
        margin-bottom: 6px;
      }
      .title-sub {
        font-weight: 400;
        font-size: 15px;
        line-height: 16px;
        color: rgba(0,0,0,0.65);
        margin-bottom: 4px;
      }
      .title-desc {
        font-weight: 400;
        font-size: 15px;
        line-height: 16px;
        color: rgba(0,0,0,0.65);
      }
    }
    .message-card-bottom {
      font-weight: 400;
      font-size: 15px;
      color: rgba(0,0,0,0.45);
      margin-top: 4px;
    }
  }
</style>